import React, { useEffect, useState, useContext } from "react";
import CardWrapper from "./CardWrapper";
import CurrencySelect from "../CurrencySelect";
import Agreement from "../Agreement";
import Buttons from "../Buttons";
import useBuyNowPaymentMethod from "../../hooks/useBuyNowPaymentMethod";
import BuyNowCard from "../BuyNowCard";
import PaymentPlan from "../PaymentPlan";
import ErrorMessages from "../ErrorMessages";
import SaveCardCheckBox from "../SaveCard";
import { PaymentInfoContext } from '../../App';
import {checkoutComEvents} from "../../events/checkoutCom.events";

export const CardPayment = ({ formik, currencyList, errorString, paymentMode, walletItem, setWalletItem, warningMessage }) => {
  const [error, SetError] = useState('');
  const paymentInfo = useContext(PaymentInfoContext);

  const getWindowHeight = () => {
    const root = document.getElementById('root');
    return root && root.getBoundingClientRect() ? root.getBoundingClientRect().height + 25 : undefined;
  };

  useEffect(() => {
    setTimeout(() => {
      parent.postMessage({
        type: 'WINDOW_SIZE_CHANGED',
        value: getWindowHeight(),
      }, '*');
    });
  }, [formik, walletItem, currencyList, errorString]);

  useEffect(() => {
    if (errorString) {
      SetError(errorString);
      formik.resetForm();
    }
  }, [errorString]);


  useEffect(() => {
    const unsubscribe = checkoutComEvents.on("frameFocus", (e) => {
      const { element } = e;
      const elements = ['card-number', 'expiry-date', 'cvv'];

      if(elements.includes(element)) {
        SetError('');
      }
    });

    return () => {
      unsubscribe();
    }
  }, [paymentMode]);

  const buyNowPaymentMethod = useBuyNowPaymentMethod();
  return (<>
    {
      buyNowPaymentMethod
        ? <BuyNowCard buyNowPaymentMethod={buyNowPaymentMethod} />
        : <CardWrapper formik={formik} walletItem={walletItem} setWalletItem={setWalletItem} />
    }
    <CurrencySelect currencyList={currencyList} formik={formik} />
    <PaymentPlan formik={formik} currencyList={currencyList} />
    {error && (
      <ErrorMessages errorString={error} />
    )}
    {
      paymentInfo?.showSaveCard && <SaveCardCheckBox type={paymentMode} formik={formik} walletItem={walletItem} />
    }
    <Agreement formik={formik} />
    <Buttons formik={formik} currencyList={currencyList} warningMessage={warningMessage} />
  </>)
}
